import React from "react";
import { Checkbox } from "antd";
import { Controller } from "react-hook-form";
import FormItemHook from "../FormItem/FormItemHook";

const CheckBoxHook = ({
  children,
  disabled = false,
  className,
  classNameCheckbox,
  type,
  placeholder = "",
  control,
  errors,
  name,
  label,
  required = false,
  showLabel,
  showOptionsName
}) => {
  return (
    <FormItemHook
      name={name}
      label={label}
      required={required}
      errors={errors[name]}
      showLabel={showLabel}
      showOptionsName={showOptionsName}
      className={className}
    >
      <Controller
        placeholder={placeholder || name}
        control={control}
        name={name}
        render={({ field }) => (
          <div>
            <Checkbox
              {...field}
              checked={field.value}
              type={type}
              disabled={disabled}
              className={classNameCheckbox}
            >
              {children}
            </Checkbox>
          </div>
        )}
      />
    </FormItemHook>
  );
};
export { CheckBoxHook };
